import LocalizedStrings from 'localized-strings';

import { PREMIUM_CARD_NAME } from 'helpers/paymentCards/constants';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hi, I would like to report a claim about my phone\n',
    },
    content: {
      exclude: {
        items: [
          `Any repairs performed with a card other than a ${PREMIUM_CARD_NAME}.`,
          "Any repair carried out without a professional invoice indicating the phone's model and IMEI code.",
        ],
        title: 'This coverage does not include',
      },
      include: {
        items: [
          'Coverage extended to your employees, up to one claim per year for the company.',
          'Repair of a phone linked to the Shine account.',
          `Repairs paid for with your ${PREMIUM_CARD_NAME} in any specialist phone repair shop in France.`,
        ],
        title: 'This coverage includes',
        withFranchise:
          'Be reimbursed up to €200 for a screen repair, with a €{total} excess, once per year for the entire company.',
        withoutFranchise:
          'Be reimbursed up to €200 for a screen repair, with no excess, up to one repair per year.',
      },
    },
    similarOffersTitle: 'Other insurances related to your coverage',
    title: 'Phone screen breakage',
  },
  fr: {
    claimButton: {
      intercomMessage:
        'Bonjour, je souhaiterais déclarer un sinistre lié à mon téléphone\n',
    },
    content: {
      exclude: {
        items: [
          `Toute réparation payée avec une carte autre qu’une carte ${PREMIUM_CARD_NAME}.`,
          'Toute réparation effectuée sans facture professionnelle indiquant le modèle de téléphone et le code IMEI.',
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          'La couverture étendue à vos employé·es, dans la limite d’un sinistre par an pour toute l’entreprise.',
          'La réparation d’un téléphone lié au compte Shine.',
          `Les réparations payées avec une carte ${PREMIUM_CARD_NAME}, dans tout magasin spécialisé en réparation de téléphone, en France.`,
        ],
        title: 'Cette garantie inclut',
        withFranchise:
          'Jusqu’à 200\xa0€ remboursés pour une réparation d’écran, avec une franchise de {total}\xa0€, une fois par an pour toute l’entreprise.',
        withoutFranchise:
          "Jusqu’à 200\xa0€ remboursés pour une réparation d’écran, sans franchise, dans la limite d'une réparation par an.",
      },
    },
    similarOffersTitle: 'Autres assurances liées à votre couverture',
    title: 'Casse écran téléphone',
  },
} as const);

export default locales;
